module.exports = __webpack_public_path__ + "static/media/enterprise.d695c2bf.svg";